/* eslint radix: ["off"] */

import React, {Component, Fragment} from 'react';
import { inject, observer } from 'mobx-react';
import { withWindowSize } from 'air-with-window-size';
import AirList from "../../../../common/components/AirList";
import TripDetail from "../TripDetail";
import TripMap from "../TripDetail/TripMap";
import FiltersBar from "../FiltersBar";
import TripItemMap from "../TripItem/TripItemMap";

import "./TripsMap.css"
import AirButton from "../../../../common/components/AirButton";

@inject('translationsStore', 'tripsStore')
@observer
class TripsList extends Component {
  constructor(props) {
    super(props);

    this.state = { pageSize: 2, selectedTrip: null };
  }

  updatePageSize = async () => {
    let deltaHeight = this.props.windowHeight - 800;
    if (deltaHeight < 0) {
      deltaHeight = deltaHeight + 48;
    }

    this.setState({ pageSize: 2 + Math.floor(deltaHeight / 255) })
    await this.props.tripsStore.changePage(1, 2 + Math.floor(deltaHeight / 255));
  }

  componentDidMount = () => {
    this.updatePageSize();
  };

  componentDidUpdate = (prevProps, prevState) => {
   if (prevProps.windowHeight !== this.props.windowHeight) {
      this.updatePageSize();
    }
  };

  onPageChange = async page => {
    await this.props.tripsStore.changePage(page, this.state.pageSize);
  }

  render() {
    const { tripsStore, translationsStore } = this.props;
    const { pageSize } = this.state;

    if(tripsStore.selectedDetailTrip) {
      return <TripDetail trip={tripsStore.selectedDetailTrip} positions={tripsStore.selectedDetailTrip.positions.map(position => position.loc)} />
    }

    return (
      <div className="TripsMapViewContainer">
        <div className="TripsMapList">
          <FiltersBar isSmall/>
          <AirList
            paginationPosition="bottom"
            pageSize={pageSize}
            dataSource={tripsStore.trips || []}
            renderItem={item => <TripItemMap key={item.id} trip={item} />}
            currentPage={tripsStore.page}
            onPageChange={this.onPageChange}
            total={tripsStore.tripsCount}
            itemName={translationsStore.translate('tripsList.pagination.label')}
          />
        </div >
        <div className="map">
          {tripsStore.mapViewSelectedTrip && (
            <Fragment>
              <AirButton
                size="large"
                light="true"
                className="TripDetailButton"
                label={translationsStore.translate('tripsList.detail.detailButton')}
                onClick={() => tripsStore.setSelectedDetailTrip(tripsStore.mapViewSelectedTrip)}
              />
              <TripMap trip={tripsStore.mapViewSelectedTrip}/>
            </Fragment>
            )
          }
        </div>
      </div>
    );
  }
}

export default withWindowSize(TripsList);



// WEBPACK FOOTER //
// ./src/components/App/Trips/TripsMap/TripsMap.js